import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useToast } from '@/components/ui/use-toast';
import { useSubscription } from '@/context/SubscriptionContext';
import { useConfig } from '@/context/ConfigContext';
import { normalizePhoneNumber } from '@/lib/profilesSync';

/**
 * Mini botón de WhatsApp para un perfil
 */
export function MiniWhatsAppButton({ profile }) {
   const whatsappNumber = profile.whatsapp || '';
   const { permissions } = useSubscription();
   const { toast } = useToast();

   const handleClick = () => {
     if (!permissions.canUseProfessionalWhatsApp) {
       toast({
         title: "Función Premium Pro",
         description: "El WhatsApp entre profesionales está disponible en el plan Premium Pro.",
         variant: "destructive",
       });
       return;
     }
     if (!whatsappNumber || whatsappNumber.trim() === '') {
       return; // No debería ocurrir (filtrado antes)
     }

     const { forWame } = normalizePhoneNumber(whatsappNumber);

     if (!forWame) {
       return;
     }

     // Abrir WhatsApp
     const waUrl = `https://wa.me/${forWame}`;
     window.open(waUrl, '_blank');
   };

      return (
        <button
          onClick={handleClick}
          className="absolute -top-2 -right-2 rounded-full p-0 border border-primary bg-[#5FCB87] hover:bg-[#4FA575] transition-colors"
          style={{ width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          title={!permissions.canUseProfessionalWhatsApp ? "Función Premium Pro" : `WhatsApp: ${profile.name}`}
          aria-label={`WhatsApp: ${profile.name}`}
        >
          <MessageCircle className="h-3.5 w-3.5 text-white" />
        </button>
      );
 }

export function ProfileActionBar({ profiles, selectedUser, onAlertClick, onOpenDialog, shareFleetAlerts = true }) {
   return null;
}
